import { render, staticRenderFns } from "./Sepultamento.vue?vue&type=template&id=52a775be&scoped=true&"
import script from "./Sepultamento.vue?vue&type=script&lang=js&"
export * from "./Sepultamento.vue?vue&type=script&lang=js&"
import style0 from "./Sepultamento.vue?vue&type=style&index=0&id=52a775be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a775be",
  null
  
)

export default component.exports